import React, { ReactNode } from 'react';

import StyledLink from '@components/Link/styles';

type Props = {
  children: ReactNode | string;
  href: string;
  replace?: boolean;
};

function Link({ children, href, replace = false }: Props) {
  return (
    <StyledLink href={href} {...(replace ? { replace: true } : {})}>
      {children}
    </StyledLink>
  );
}

export default Link;
